import styled from '@emotion/styled';

export const CardLoanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.sm};
`;

export const CardLoanTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CardLoanTopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const CardLoanBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;

export const CardLoanBottomLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const CardLoanBottomLeftItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xs};
`;
